import {ActionReducerMap} from '@ngrx/store';
import {AppState} from './state';
import {catalogReducer} from './catalog';
import {cartReducer} from './cart';
import {userReducer} from './user';
import {InjectionToken} from '@angular/core';
import { storeReducer } from './store-state';

export const reducers = {
    catalogState: catalogReducer,
    cartState: cartReducer,
    userState: userReducer,
    storeState: storeReducer
};

export function getReducers() {
    return reducers;
}

export const reducerToken =
    new InjectionToken<ActionReducerMap<AppState>>('appState', {
        factory: () => getReducers()
    });


export const reducerProvider = [
    {provide: reducerToken, useFactory: getReducers}
];
